import {
  FormLayout,
  MultiSelectStoreDropdown,
  TextInput,
} from 'components/common'
import { FieldErrors, UseFormRegister, UseFormSetValue } from 'react-hook-form'
import { getInputErrorMessage } from 'utils/helpers/getNestedErrorMessage'
import { TalabatConfigFormFields } from 'utils/schema/talabatConfigSchema'
import { talabatConfigurationFields } from './utils'

const { PRIORITY_STORES, PRIORITY_SYNC_BATCH_SIZE } = talabatConfigurationFields

type Props = {
  register: UseFormRegister<TalabatConfigFormFields>
  setValue: UseFormSetValue<TalabatConfigFormFields>
  priorityStores?: string[]
  errors: FieldErrors<TalabatConfigFormFields>
}

/**
 * Priority (dark) stores synced to Talabat on their own dedicated, faster
 * cron — independent of the regular/delta product sync crons. Selecting
 * stores here is what drives that cron; selecting none turns it off.
 */
const TalabatPriorityStoreSection = ({
  register,
  setValue,
  priorityStores,
  errors,
}: Props) => {
  return (
    <>
      <h3 className="title mt-4">Priority Store Sync Configuration</h3>
      <FormLayout>
        <div className="grid gap-4 mid-md:grid-cols-2">
          <MultiSelectStoreDropdown
            label={PRIORITY_STORES.label}
            name={PRIORITY_STORES.key}
            setValue={setValue}
            error={
              (errors as Record<string, any>)?.[PRIORITY_STORES.key]?.message
            }
            defaultSelected={priorityStores as []}
            resetForm={false}
            hintText="Stores pushed to Talabat by the dedicated priority sync cron. Selecting none turns that cron off."
          />

          <TextInput
            required
            type="number"
            register={register}
            name={PRIORITY_SYNC_BATCH_SIZE.key}
            label={PRIORITY_SYNC_BATCH_SIZE.label}
            error={getInputErrorMessage(errors, PRIORITY_SYNC_BATCH_SIZE)}
            placeholder="e.g., 5"
            hintText="Number of priority stores synced concurrently per cron tick"
          />
        </div>
      </FormLayout>
    </>
  )
}

export default TalabatPriorityStoreSection
